import island0 from "/app/apps/help/site/controls.tsx"
import island1 from "/app/apps/help/site/documentation.tsx"
import "/app/apps/help/site/styles.css"
import { domHost, hydrateIslands } from '@ketvietlab/ketjs-view'
hydrateIslands(domHost(document), document, { "controls": island0, "documentation": island1 })